import React, { Suspense } from 'react'
const RegisterPageBase = React.lazy(() => import('./Register'))

export const RegisterPage = () => (
  <Suspense fallback={null}>
    <RegisterPageBase />
  </Suspense>
)
